<template>
    <div>
        <premium-modal
            v-model="valueLocal"
            fullscreen
        >
            <div class="_dflex _flexdir-column _min-h_full _justify-content-center _position-relative">
                <div class="float-header__cb-bg" />
                <div class="container">
                    <premium-form-callback />
                </div>
            </div>
        </premium-modal>
        <slot name="opener" :open="onOpen" />
    </div>
</template>
<script>
import { useVModel } from '../../assets/js/vue/mixins/useVModel';
import PremiumFormCallback from './PremiumFormCallback.vue';
import PremiumModal from './PremiumModal.vue';

export default {
    name: 'PremiumModalCallback',
    mixins: [useVModel],
    components: {
        PremiumFormCallback,
        PremiumModal,
    },
    props: {
        value: Boolean,
    },
    data() {
        return {
            valueLocal: false,
            modelPropsEqualLocal: [
              ['value', 'valueLocal'],
            ],
        };
    },
    methods: {
        onOpen() {
            this.valueLocal = true;
        },
    },
};
</script>
